import { Avatar, Button, Dropdown, message, Space, Tabs, TabsProps, Tag } from 'antd'
import { ReactNode, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../Organization/components/Spinner';
import { GetBrand, GetOrgBrands, SoftDeleteBrand } from '../../../API/endpoints/Brands';
import { GetOrg } from '../../../API/endpoints/Organization';
import BrandInfo from '../../Organization/components/BrandInfo';
import MatketPreferences from '../../Organization/components/MatketPreferences';
import Products from '../../Organization/components/Products';
import Assets from '../../Organization/components/Assets';
import { STATUS_APPROVED, TAB_ASSETS, TAB_INFO, TAB_MARKETS, TAB_PRODUCTS } from '../../../constants/constants';
import RightArrowIcon from '../../../components/icons/RightArrowIcon';
import FacebookIcon from '../../../components/icons/FacebookIcon';
import LinkedinIcon from '../../../components/icons/LinkedinIcon';
import { Link } from 'react-router-dom';
import { avatarBg, formatAmount } from '../../../common/helpers';
import LinkIcon from '../../../components/icons/LinkIcon';
import ThreeDotsIcon from '../../../components/icons/ThreeDotsIcon';
import DeleteModal from '../../Organization/components/DeleteModal';
import { useBrandTabsContext } from '../../Organization/contexts/BrandTabsContext';
import InstagramIcon from '../../components/BrandsPartnerComponents/InstagramIcon';

interface Props {
    orgId: string
}
const Brands = (props: Props) => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [messageApi, contextHolder] = message.useMessage()
    const { activeTab, setActiveTab, setProductID } = useBrandTabsContext();

    const [orgId, setOrgId] = useState("");
    const [activeBrand, setActiveBrand] = useState("");
    const [isDeleteItem, setIsDeleteItem] = useState<any>({});

    const [brands, setBrands] = useState<any>([]);
    const [orgDetails, setOrgDetails] = useState<any>({});
    const [loading, setLoading] = useState(true);

    const [brandDetails, setBrandDetails] = useState<any>({});
    const [brandLoading, setBrandLoading] = useState(true);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const brand = queryParams.get('brand');
        if (brand) {
            setActiveBrand(brand)
            setProductID("")
        }
    }, [location])

    useEffect(() => {
        setOrgId(params?.orgid || props?.orgId || "")
    }, [params?.orgid, props?.orgId]);

    useEffect(() => {
        if (orgId) {
            fetchData();
        }
    }, [orgId,]);

    useEffect(() => {
        if (activeBrand) {
            getBrandData();
        } else {
            setBrandDetails({})
            setBrandLoading(false);
        }
    }, [activeBrand]);

    useEffect(() => {
        if (brands?.length > 0 && activeBrand == "") {
            setActiveBrand(brands[0]?.id)
        }
    }, [brands, activeBrand])

    const getBrandData = () => {
        setBrandLoading(true);
        GetBrand(activeBrand).then((res: any) => {
            setBrandDetails(res?.data)
            setBrandLoading(false);
        }).catch((err) => {
            setBrandDetails({})
            setBrandLoading(false);
        });
    }


    const fetchData = async () => {
        try {
            setLoading(true);
            const [brandsRes, orgRes] = await Promise.all([
                GetOrgBrands(orgId),
                GetOrg(orgId),
            ]);
            setBrands(brandsRes?.data?.rows);
            setOrgDetails(orgRes?.data);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching data:", err);
            setLoading(false);
        }
    }


    const onSuccessDeleteBrand = () => {
        messageApi.success("Brand data deleted successfully");
        const newBrands = brands.filter((item: any) => item?.id !== isDeleteItem?.id)
        setBrands([...newBrands])
        setActiveBrand(newBrands?.[0]?.id || "")

        setIsDeleteItem({});
    }


    const onChangeTab = (tab: string) => {
        setActiveTab(tab)
        setProductID("")
    }

    const setCurrentUrl = (id: string) => {
        const params = new URLSearchParams(location.search);
        params.set('brand', id);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const openLink = (link: string) => {
        if (link) {
            const fullUrl = link.startsWith("http") ? link : `https://${link}`;
            window.open(fullUrl, "_blank", "noopener,noreferrer");
        }
    }

    const actionOptions = useMemo(() => {
        let items: any = [];
        items.push(
            {
                key: '1',
                label: "Edit brand data",
                onClick: () => {
                    navigate(`/editOrgBrand/${orgId}/${brandDetails?.id}`)
                }
            }
        )

        items.push({
            key: '2',
            danger: true,
            label: "Delete brand data",
            onClick: () => setIsDeleteItem(brandDetails)
        })

        return items;
    }, [brandDetails, orgId])



    const items: TabsProps['items'] = useMemo(() => ([
        {
            key: TAB_INFO,
            label: 'Info',
            children: <BrandInfo data={brandDetails} />,
        },
        {
            key: TAB_MARKETS,
            label: 'Market Preferences',
            children: <MatketPreferences brandId={brandDetails?.id} />,
        },
        {
            key: TAB_PRODUCTS,
            label: 'Products',
            children: <Products brand={brandDetails} />,
        },
        {
            key: TAB_ASSETS,
            label: 'Assets',
            children: <Assets brand={brandDetails} isBrandUser={true} />,
        },
    ]), [brandDetails]);

    const brandList = useMemo(() => {
        return brands.map((brand: any) => {
            return (
                <div key={brand?.id} className={`${activeBrand === brand?.id ? "bg-[#D1E9FF]" : ""} flex items-center justify-between px-[10px] py-[8px] rounded-[4px] cursor-pointer`} onClick={() => {
                    setActiveBrand(brand?.id)
                    setProductID("")
                    setCurrentUrl(brand?.id);
                }}>
                    <div>
                        <p className={`${activeBrand === brand?.id ? "text-[#1849A9]" : ""} text-[13px] font-[500] m-0`}>{brand?.brand_name}</p>
                        {
                            brand?.status !== STATUS_APPROVED ? (
                                <Tag className='mt-[6px] capitalize rounded-[12px] font-[500]' bordered={false} color={brand?.status === STATUS_APPROVED ? 'success' : orgDetails?.is_active ? 'purple' : 'blue'}>{brand?.status === STATUS_APPROVED ? "Approved" : orgDetails?.is_active ? "Activated" : brand?.status?.toLowerCase()}</Tag>

                            ) : (
                                <></>
                            )
                        }
                    </div>
                    {activeBrand === brand?.id ? (
                        <RightArrowIcon />
                    ) : (
                        <></>
                    )}

                </div>
            )
        })
    }, [brands, activeBrand])


    const socialMediaLinks = useMemo(() => {
        return brandDetails?.social_media?.map((s: any) => {
            let icon: ReactNode = <></>;
            switch (s?.platform) {
                case "Facebook":
                    icon = <FacebookIcon />
                    break;

                case "Instagram":
                    icon = <InstagramIcon />
                    break;

                case "Linkedin":
                    icon = <LinkedinIcon />
                    break;

                default:
                    break;
            }
            return (
                <Link to={`//${s?.url}`} target='_blank' key={s?.id}>
                    {icon}
                </Link>
            )
        })
    }, [brandDetails])


    const marketPlaces = useMemo(() => (
        brandDetails?.market_place?.map((m: any, index: number) => (
            <Tag key={index} bordered={false} className='bg-[#F2F4F7] font-[500]'>{m?.platform}</Tag>
        ))
    ), [brandDetails])

    return (
        <div className='w-full h-[calc(100vh-49px)]'>
            {contextHolder}
            <div className='flex h-full'>
                {/* Left Panel   */}
                <div className='w-[220px] bg-white h-[calc(100vh-49px)] p-[10px] flex flex-col'>
                    {loading ? (
                        <Spinner />

                    ) : (
                        <>
                            <Space className='!items-start'>
                                <p className='text-[12px] text-[#667085]'>ORG:</p>
                                <p className='text-[12px] text-[#667085]'>{orgDetails?.company_name || ""}</p>
                            </Space>

                            <div className='flex flex-col gap-y-[6px] flex-1 overflow-auto'>
                                {brandList}
                            </div>
                        </>
                    )}
                    <div className='bg-gradient-to-tr from-[#B2DDFF] to-white rounded-[8px] p-[12px] mt-[10px]'>
                        <p className='mb-[12px] text-[13px] font-[500]'>Want to add a new brand of yours?</p>
                        <Button type='primary' onClick={() => navigate(`/createNewBrand/${orgId}`)}>Add Brand</Button>
                    </div>
                </div>

                {/* Right Panel  */}
                <div className='m-[16px] mb-0 w-[calc(100%-252px)]'>

                    {/* Message Bar  */}
                    {brandDetails?.status !== STATUS_APPROVED ? (
                        <div className='w-full p-[20px] bg-[#FEDF89] flex items-center justify-between gap-x-[16px] mb-[16px] rounded-[8px]'>
                            <div className='flex-1'>
                                <p className='mb-[8px] text-[#93370D] text-[14px] font-[600]'>Approval in Progress</p>
                                <p className='m-0 text-[13px] text-[#344054]'>Thank you for submitting your brand details. Our team is currently reviewing your submission — we'll notify you once it's approved or if we need anything else.</p>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}


                    {/* Header Section */}
                    <div className='bg-white rounded-[8px] p-[16px] w-full grid grid-cols-7 mb-[6px]'>
                        {brandLoading ? (
                            <div className='w-full col-span-7 h-[90px]'>
                                <Spinner />
                            </div>

                        ) : (
                            activeBrand && Object.keys(brandDetails).length > 0 ? (
                                <>
                                    <div className='col-span-2 flex gap-x-[12px] border-r border-[#E4E7EC] pr-[40px]'>
                                        <Avatar style={{ backgroundColor: avatarBg(brandDetails?.brand_name?.charAt(0)) }}>{brandDetails?.brand_name?.charAt(0)}</Avatar>
                                        <div>
                                            <div className='flex items-center gap-x-[8px]'>
                                                <p className='m-0 text-[#1D2939] text-[14px] font-[500] break-all'>{brandDetails?.brand_name}</p>
                                                <Tag className='capitalize rounded-[12px] font-[500]' bordered={false} color={brandDetails?.status === STATUS_APPROVED ? 'success' : orgDetails?.is_active ? 'purple' : 'blue'}>{brandDetails?.status === STATUS_APPROVED ? "Approved" : orgDetails?.is_active ? "Activated" : brandDetails?.status?.toLowerCase()}</Tag>
                                            </div>
                                            <p className='mt-[4px] text-[#475467] text-[12px] mb-[4px]'>{brandDetails?.years_of_operation} • {formatAmount(brandDetails?.current_revenue)}</p>
                                            {brandDetails?.website ? (
                                                <div className='flex gap-x-[4px] items-center cursor-pointer' onClick={() => openLink(orgDetails?.website)}>
                                                    <LinkIcon />
                                                    <p className='max-w-[170px] truncate text-[12px] m-0 text-[#175CD3]'>{orgDetails?.website}</p>
                                                </div>
                                            ) : (
                                                <></>
                                            )}

                                        </div>
                                    </div>
                                    <div className='col-span-2 flex flex-col gap-y-[20px] border-r border-[#E4E7EC] ml-[40px]  pr-[40px]'>
                                        <div className='flex gap-x-[16px] items-center'>
                                            <p className='text-[#475467] text-[12px] m-0'>Social:</p>
                                            <Space>
                                                {socialMediaLinks}
                                            </Space>
                                        </div>
                                        <div className=''>
                                            <p className='text-[#475467] text-[12px] mb-[8px]'>Marketplaces</p>
                                            <div className='flex'>
                                                {marketPlaces}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-span-3 flex gap-y-[20px] ml-[40px]'>
                                        <div className='flex flex-col gap-y-[20px] flex-1'>
                                            <div className='flex gap-x-[16px] items-center'>
                                                <p className='text-[#475467] text-[12px] m-0'>Country of Origin:</p>
                                                <p className='text-[#1D2939] text-[12px] m-0 font-[500]'>{orgDetails?.region?.name}</p>
                                            </div>
                                            <div className=''>
                                                <p className='text-[#475467] text-[12px] mb-[8px]'>Address</p>
                                                <p className='text-[#1D2939] text-[12px] mb-[4px] font-[500]'>{orgDetails?.company_address_line1}</p>
                                                <p className='text-[#1D2939] text-[12px] mb-[4px] font-[500]'>{orgDetails?.company_address_line2}</p>
                                                <p className='text-[#1D2939] text-[12px] mb-[4px] font-[500]'>{orgDetails?.city}, {orgDetails?.state} - {orgDetails?.company_address_postal_code}</p>
                                            </div>
                                        </div>
                                        <Dropdown menu={{ items: actionOptions }}>
                                            <Button type='text' icon={<ThreeDotsIcon />} />
                                        </Dropdown>
                                    </div>
                                </>
                            ) : (
                                <p className='text-[14px] text-[#475467] m-0 text-center col-span-7'>No Brand Selected!</p>
                            )

                        )}

                    </div>

                    {/* Tabs Section  */}
                    {activeBrand && Object.keys(brandDetails).length > 0 ? (
                        <Tabs defaultActiveKey={TAB_INFO} items={items} color='#12B76A' animated activeKey={activeTab} onChange={(tab: string) => onChangeTab(tab)} />
                    ) : (
                        <></>
                    )}

                </div>
            </div>
            <DeleteModal
                title="Brand"
                name={isDeleteItem?.brand_name}
                item={isDeleteItem}
                onCancel={() => setIsDeleteItem({})}
                onSuccess={() => onSuccessDeleteBrand()}
                api={SoftDeleteBrand}
            />
        </div>
    )
}

export default Brands